module.exports = __webpack_public_path__ + "static/media/Arrow-down-common-red.8192c88d.svg";